/**
 * Language Configuration - Single Source of Truth
 * This file defines all supported languages and default language for the application
 */

export const SUPPORTED_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        nativeName: 'English',
        dir: 'ltr',
        flag: '🇺🇸'
    },
    {
        code: 'es',
        name: 'Spanish',
        nativeName: 'Español',
        dir: 'ltr',
        flag: '🇪🇸'
    },
    {
        code: 'fr',
        name: 'French',
        nativeName: 'Français',
        dir: 'ltr',
        flag: '🇫🇷'
    }
];

// Default language code
export const DEFAULT_LANGUAGE = 'en';

// Helper to get language codes only
export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(lang => lang.code);

// Helper to check if a language code is supported
export const isValidLanguage = (code) => {
    return LANGUAGE_CODES.includes(code);
};

// Helper to get language object by code
export const getLanguageByCode = (code) => {
    return SUPPORTED_LANGUAGES.find(lang => lang.code === code) || SUPPORTED_LANGUAGES.find(lang => lang.code === DEFAULT_LANGUAGE);
};
